"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Hoodoo_OnTurnStartedEventHandlerScript = void 0;
const AbilityDamage_1 = require("../../core/AbilityDamage");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let Effect_Hoodoo_OnTurnStartedEventHandlerScript = class Effect_Hoodoo_OnTurnStartedEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.TurnStarted) {
            return;
        }
        container.applyAttackWithDamage({
            sequence,
            abilityKey: "Hoodoo",
            attackType: "magic",
            attackerId: handler.subject,
            targetId: handler.args.scriptArgs.targetId,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus((0, Random_1.randomPercent)() <= 50 ? "Nature" : "Death", 100)
            ]
        });
    }
};
Effect_Hoodoo_OnTurnStartedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Hoodoo_OnTurnStarted")
], Effect_Hoodoo_OnTurnStartedEventHandlerScript);
exports.Effect_Hoodoo_OnTurnStartedEventHandlerScript = Effect_Hoodoo_OnTurnStartedEventHandlerScript;
